<template>
  <div id="new-invoice">
    <div id="left">
      <div id="preview">
        <div>
          <div class="header">
            <h1>{{user.company_name}}</h1>
            <div class="column">
              <h2 class="gray accent">7/16/2020</h2>
              <h2>{{invoice_id}}</h2>
            </div>
          </div>
          <hr />
          <div id="info" class="row">
            <div class="column">
              <p>To:</p>
              <h3>{{client.contact}}</h3>
              <p>{{client.address_1}}</p>
              <p>{{client.address_2}}</p>
              <p>{{client.country}}</p>
            </div>
            <div class="column">
              <p>Due Date</p>
              <h3>07/30/2020</h3>
              <p>Total Due</p>
              <h3>{{total_amount}}</h3>
            </div>
          </div>
          <div id="line_items">
            <div class="row">
              <p>Description</p>
              <p>Price</p>
              <p>Quantity</p>
              <p>Line Total</p>
            </div>
            <div class="row" v-for="(item, index) in lines" :key="index">
              <p>{{item.description}}</p>
              <p>${{Number(item.price).toLocaleString()}}</p>
              <p>{{item.quantity}}</p>
              <p>${{(item.price * item.quantity).toLocaleString()}}</p>
            </div>
          </div>
        </div>
        <div id="footer">
          <div class="row">
            <div class="column">
              <p>Questions? Contact us at</p>
              <p>{{user.number}}</p>
              <p>{{user.support_email}}</p>
            </div>
            <img v-bind:src="user.img" alt />
            <div class="column">
              <p>{{user.address_1}}</p>
              <p>{{user.address_2}}</p>
              <p>{{user.country}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="right">
      <div class="data-row">
        <div class v-for="(item, index) in lines" :key="index" @click="edit = index">
          <div class="row" v-if="edit == index || item.description == ''">
            <input
              type="text"
              placeholder="Description"
              v-model="lines[index].description"
              @change="saveData"
              v-on:keyup.enter="edit = null; saveData()"
            />
            <input
              type="number"
              placeholder="Price"
              v-model="lines[index].price"
              @change="saveData"
              v-on:keyup.enter="edit = null; saveData()"
            />
            <input
              type="number"
              placeholder="Qauntity"
              v-model="lines[index].quantity"
              @change="saveData"
              v-on:keyup.enter="edit = null; saveData()"
            />
            <i class="fas fa-times delete" @click="lines.splice(index, 1)"></i>
          </div>
          <div class="row" v-else>
            <p>{{item.description}}</p>
            <p>{{item.price}}</p>
            <p>{{item.quantity}}</p>
            <i class="fas fa-times delete" @click="lines.splice(index, 1)"></i>
          </div>
        </div>
      </div>
      <select v-model="client">
        <option v-for="(client, index) in clients" :key="index" :value="client">{{ client.company }}</option>
      </select>
      <button id="newLine" @click="saveData(); addLine();">Add a new line</button>
      <button @click="download" style="height: 50px; width: 250px">Download PDF</button>
      <div>
        <button @click="saveInvoice">Save Invoice</button>
      </div>
    </div>
    <p id="warning" v-if="edit != null">
      Unsaved Changes, press
      <strong>'enter'</strong> to save line
    </p>
  </div>
</template>

<script>
import jsPDF from "jspdf";
import html2canvas from "html2canvas"; // eslint-disable-line
import firebase from "firebase";
import { db } from "../main";

export default {
  name: "NewInvoice",
  data() {
    return {
      uid: "",
      user: {
        company_name: "TrakYak",
        number: "123-432-1233",
        support_email: "support@trakyak.com",
        address_1: "123 Left Street",
        address_2: "Modesto, CA 95355",
        country: "United States",
        img: "https://i.imgur.com/JSrZf6E.png",
        imgUri: null,
        accent_color: "0cce6b",
      },
      client: {},
      lines: [
        { description: "Logo Design", price: 100, quantity: 3 },
        { description: "Web Design", price: 5455, quantity: 1 },
      ],
      edit: null,
      same_bill_shipping: false,
      invoice_id: "014298",
      curr_date: "07/04/2020",
      due_date: "",
      lines_desc: [],
      lines_price: [],
      lines_quantity: [],
      lines_total: [],
      total_amount: "",
      daysDue: 7,
      clients: [],
    };
  },
  firestore() {
    var uid = firebase.auth().currentUser.uid;
    this.uid = uid;
    return {
      user: db.collection("users").doc(uid),
      clients: db.collection("clients").where("user_id", "==", uid),
    };
  },
  methods: {
    saveInvoice: function () {
      this.saveData();
      var date = new Date();
      var currDate = date.toLocaleDateString();

      function addDays(date, days) {
        var copy = new Date(Number(date));
        copy.setDate(date.getDate() + days);
        return copy;
      }

      var dueDate = addDays(date, this.daysDue);
      console.log(dueDate);

      db.collection("invoices").add({
        invoice_id: this.invoice_id,
        user_id: this.user.uid,
        client_id: this.client.id,
        client: this.client.company,
        lines: this.lines,
        amount_due: this.total_amount,
        due_date: dueDate.toLocaleDateString(),
        date_created: currDate,
        status: "Draft",
      });
    },
    saveData: function () {
      let total = 0;
      let line_total = 0;
      this.lines.forEach((element) => {
        if (Object.keys(element).length == 0) {
          this.lines.pop(element);
        } else {
          this.lines_desc.push(element.description);
          this.lines_price.push(`$${element.price.toLocaleString()}`);
          this.lines_quantity.push(element.quantity);
          total += element.price * parseFloat(element.quantity);
          line_total = element.price * parseFloat(element.quantity);
          this.lines_total.push(`$${line_total.toLocaleString()}`);
        }
      });

      this.total_amount = `$${total.toLocaleString()}`;
      this.edit = null;
    },

    download: function () {
      this.saveData();

      var str_quantity = [];

      this.lines_quantity.forEach((line) => {
        str_quantity.push(line.toString());
      });

      //this.company.imgUri = imgDataUri;

      var doc = new jsPDF({ unit: "mm", format: "a4" });
      /* Header */

      doc.setFontType("bold");
      doc.setFontSize(40);
      doc.text(this.user.company_name, 10, 20, { align: "left" });
      doc.setFontType("normal");
      doc.setFontSize(20);
      doc.text(this.invoice_id, 200, 20, { align: "right" });
      doc.setTextColor(100, 100, 100);
      doc.setFontSize(13);
      doc.text(this.curr_date, 200, 12, { align: "right" });

      doc.setDrawColor(200, 200, 200);
      doc.line(10, 30, 200, 30);

      /* Body */
      doc.setFontSize(13);
      doc.setFontType("normal");

      if (this.same_bill_shipping) {
        doc.text("Billing & Shipping", 200, 300, { align: "right" });
      } else {
        doc.text("Billing", 200, 300, { align: "right" });
        //Shipping
        doc.text("Shipping", 200, 400, { align: "right" });
        doc.text(this.client.name, 200, 345, { align: "right" });
        doc.text(this.client.bill_address_1, 200, 352.5, { align: "right" });
        doc.text(this.client.bill_address_2, 200, 360, { align: "right" });
        doc.text(this.client.bill_country, 200, 367.5, { align: "right" });
      }
      doc.setTextColor(0, 0, 0);
      // Billing
      doc.setTextColor(100, 100, 100);
      doc.text("To:", 10, 45, { align: "left" });
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(20);
      doc.text(this.client.name, 10, 53, { align: "left" });
      doc.setFontSize(13);
      doc.text(this.client.bill_address_1, 10, 60, { align: "left" });
      doc.text(this.client.bill_address_2, 10, 67.5, { align: "left" });
      doc.text(this.client.bill_country, 10, 75, { align: "left" });

      doc.setTextColor(100, 100, 100);
      doc.text("Due Date", 200, 45, { align: "right" });
      doc.setFontSize(20);
      doc.setTextColor(0, 0, 0);
      doc.text("07/15/2020", 200, 53, { align: "right" });
      doc.setFontSize(13);
      doc.setTextColor(100, 100, 100);
      doc.text("Amount Due", 200, 60, { align: "right" });
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(30);
      doc.setFontType("bold");
      doc.text(this.total_amount, 200, 72, { align: "right" });
      doc.setFontSize(13);

      doc.setFontType("normal");
      doc.setTextColor(100, 100, 100);

      doc.text("Description", 10, 90, { align: "left" });
      doc.text("Price", 140, 90, { align: "right" });
      doc.text("Quantity", 170, 90, { align: "right" });
      doc.text("Line Total", 200, 90, { align: "right" });

      doc.line(10, 365, 120, 365);
      doc.line(130, 455, 130, 450);
      doc.line(140, 385, 200, 385);

      doc.setTextColor(0, 0, 0);
      doc.setFontSize(16);

      doc.text(this.lines_desc, 10, 100, {
        align: "left",
        lineHeightFactor: 2,
      });

      doc.text(this.lines_price, 140, 100, {
        align: "right",
        lineHeightFactor: 2,
      });

      doc.text(str_quantity, 170, 100, {
        align: "right",
        lineHeightFactor: 2,
      });

      doc.text(this.lines_total, 200, 100, {
        align: "right",
        lineHeightFactor: 2,
      });

      doc.setFillColor("#" + this.user.accent_color);
      doc.rect(0, 260, 210, 125, "f");

      /* Footer */

      doc.setFontSize(11);
      doc.setTextColor("#767676");
      doc.text(this.user.address_1, 200, 272, { align: "right" });
      doc.text(this.user.address_2, 200, 280.5, { align: "right" });
      doc.text(this.user.country, 200, 288, { align: "right" });

      doc.text("Questions? Contact us at", 10, 272, { align: "left" });
      doc.text(this.user.number, 10, 280.5, { align: "left" });
      doc.text(this.user.support_email, 10, 288, { align: "left" });

      var myImage = new Image();
      myImage.src = this.user.img;
      myImage.onload = function () {
        doc.addImage(myImage, "png", 89.5, 262, 33, 33);
        //doc.output("dataurlnewwindow");
        doc.save("test.pdf");
      };
      //doc.save("test.pdf");
    },
    addLine: function () {
      this.lines.push({
        description: "",
        price: 0.0,
        quantity: 0,
      });
      this.edit = this.lines.length - 1;
    },
    test: function (i) {
      console.log(i);
      this.lines.pop(i);
    },
  },
};
</script>

<style lang="scss">
#newLine {
  width: 300px;
  background: #cecece;
  border: solid 2px #afafaf;
  padding: 25px 0;
  border-radius: 5px;
  font-size: 1.2rem;
  color: #808080;
}

#warning {
  position: absolute;
  bottom: 0px;
  right: 15px;
  color: rgb(221, 57, 57);
}

#new-invoice {
  display: flex;
  justify-content: space-between;
  align-content: center;

  .gray {
    color: rgb(100, 100, 100);
  }

  .accent {
    font-weight: 300;
    font-size: 1.2rem;
    margin: 0;
  }

  .column {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h2 {
      margin: 0;
    }
  }

  #left {
    width: 60%;
    min-height: 100vh;

    #preview {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-content: center;
      height: 100%;

      .row {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      hr {
        border-top: 2px solid;
        margin: 25px 0;
      }

      h1 {
        font-size: 2.5rem;
        margin: 0;
      }
      .header {
        display: flex;
        justify-content: space-between;
        align-content: center;
        padding: 20px 35px 0 35px;
      }

      #info {
        padding: 0 35px;
        .column {
          width: 50%;
          align-items: flex-end;
          justify-content: flex-start;

          h3 {
            font-size: 1.5rem;
            margin: 5px 0;
          }

          p {
            text-align: right;
            width: 90%;
            margin: auto 0;
          }

          &:first-of-type {
            align-items: flex-start;
            text-align: left;

            p {
              text-align: left;
            }
          }
        }
      }

      #line_items {
        padding: 0 35px;
        p {
          width: 100%;
          text-align: right;

          &:first-of-type {
            text-align: left;
          }
        }
      }

      #footer {
        background: #0cce6b;
        margin-top: auto;
        margin-top: 150px;
        justify-self: flex-end;

        img {
          height: 125px;
        }
        .column {
          padding: 0 35px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;

          &:last-of-type {
            align-items: flex-end;
          }
        }
      }
    }
  }

  #right {
    width: 40%;

    .row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 95%;
      margin: 10px auto;
      cursor: pointer;

      input {
        border: none;
        outline: none;
        border-bottom: solid;
        font-family: Avenir, Helvetica, Arial, sans-serif;
      }

      p {
        border-bottom: solid #fff;
      }

      .delete {
        text-align: center;
        transition: 0.1s;

        &:hover {
          color: rgb(221, 57, 57);
        }
      }

      input,
      p {
        font-size: 1rem;
        margin: 0 15px;
        text-align: left;
        width: 25%;

        &:nth-child(1) {
          width: 50%;
        }
      }
    }
  }
}
</style>
